import HttpRequest from '@/util/HttpRequest'

function removeLocalStorage (key) {
  localStorage.removeItem(key)
}
function setLocalStorage (key, value, tts) {
  const obj = {
    value : value,
    expire : Date.now() + tts
  }
  if (!tts) {
    delete obj.expire
  }
  localStorage.removeItem(key)
  localStorage.setItem(key, JSON.stringify(obj))
}
function getLocalStorage (key) {
  const obj = JSON.parse(localStorage.getItem(key))
  if (obj) {
    if (!obj.expire || obj.expire > Date.now()) {
      return obj.value
    } else {
      localStorage.removeItem(key)
    }
  }
  return null
}

function setPathWithMenus (menus, path= []) {
  for(let i = 0; i < menus.length; i++) {
    const newPath = []

    if (menus[i].breadcrumb) {
      newPath.push(...menus[i].breadcrumb)
    } else {
      if (menus[i].visible === 'tab') {
        newPath.push(...path)
      } else {
        newPath.push(...path.concat(menus[i].name))
      }
    }

    menus[i].path = newPath
    if (menus[i].submenu) setPathWithMenus(menus[i].submenu, newPath)
  }
}

export default {
  SET_MENU (state, data) {
    // breadcrumb 에 사용되는 Path 를 추가한다.
    if (data && data.length > 0) {
      setPathWithMenus(data, [])
    }
    state.list = data
  },

  UPDATE_PAGE_LIST (state, data) {
    state.pagePath = data
    state.pageTitle = data[data.length -1].label
  },

  SET_MODAL_LIST (state, data) {
    if (!data) {
      return
    }

    // 쿠키 검사 후 노출할 팝업 리스트를 저장한다.
    const _noticeList = getLocalStorage('modal_main_notice') || []
    let modalNoticeIdList = (typeof _noticeList === 'string') ? JSON.parse(_noticeList) : _noticeList
    if (modalNoticeIdList.length > 0) {
      // 만료 시간이 지난 데이터는 제거한다.
      modalNoticeIdList = modalNoticeIdList.filter(notice => notice.expire > Date.now())
    }

    state.modalItems = data.filter(item => {
      if (modalNoticeIdList.length > 0) {
        const notice = modalNoticeIdList.find(notice => notice.value === item.id)
        if (notice) {
          return false
        }
      }
      return true
    })
  },

  CLOSE_MODAL (state, modalItemId) {
    // 팝업을 닫는다.
    state.modalItems = state.modalItems.filter(item => item.id !== modalItemId)
  },

  DELETE_MODAL_DAY (state, data) {
    const id = data.id
    const day = data.day
    const _noticeList = getLocalStorage('modal_main_notice') || []
    let modalNoticeIdList = (typeof _noticeList === 'string') ? JSON.parse(_noticeList) : _noticeList
    if (modalNoticeIdList.length > 0) {
      modalNoticeIdList = modalNoticeIdList.filter(notice => notice.value !== id)
    }
    modalNoticeIdList.push({
      value: id,
      expire: Date.now() + 1000 * 60 * 60 * 24 * day
    })
    setLocalStorage('modal_main_notice', JSON.stringify(modalNoticeIdList))
  },

  REVERT_MODAL (state, id) {
    const _noticeList = getLocalStorage('modal_main_notice') || []
    let modalNoticeIdList = (typeof _noticeList === 'string') ? JSON.parse(_noticeList) : _noticeList
    if (modalNoticeIdList.length > 0) {
      modalNoticeIdList = modalNoticeIdList.filter(notice => notice.value !== id)
    }
    setLocalStorage('modal_main_notice', JSON.stringify(modalNoticeIdList))
  },

  SET_AVAILABLE_BOARD_IDS (state, data) {
    state.availableBoardIds = data
  }
}
